import { ACTION } from '@cvent/react-analytics';

export const changeReactionStreamVisibility = {
  id: 'change_reaction_stream_visibility',
  name: 'Change reaction stream visibility',
  type: ACTION,
  attributes: ['sessionId', 'visible', 'streamOffsetSecs'],
  destinations: ['Mixpanel', 'Analytics', 'AttendeeActivities'],
  objectIdAttribute: 'sessionId',
  activityType: 'session.reactionsVisibilityChanged'
};

export const addReactionClick = {
  id: 'add_reaction_click',
  name: 'Add reaction click',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics', 'AttendeeActivities'],
  attributes: ['sessionId', 'reactionType', 'reactionName', 'streamOffsetSecs'],
  objectIdAttribute: 'sessionId',
  activityType: 'session.reactionAdded'
};
